export default "__VITE_ASSET__Bayl$3OX__"